export default __webpack_public_path__ + "static/media/26.b8d7334c.jpg";